import { Http } from "../../../node_modules/@angular/http";
import { Configurations } from "../core/configurations";
import { Injectable } from "../../../node_modules/@angular/core";

@Injectable()
export class LangService {
    httpService:Http;
    constructor(private http:Http,private configuration:Configurations) {
        this.httpService=http;
    }
    setLang(codeLang:string) {
        this.httpService.get(Configurations.appBaseServiceUrl+"Localization/ChangeCulture?cultureName="+
            codeLang+"&returnUrl="+encodeURI(Configurations.appBaseServiceUrl)).subscribe();
    }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/lang.services.ts